import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';
import {MeusLaudosPdfModel} from "./meus-laudos-pdf.model";
import {ClientesService} from "../../clientes/clientes.service";
import {MercadoriasService} from "../../mercadorias/mercadorias.service";
import {TiposClientesService} from "../../clientes/tipos-clientes.service";
import {UnidadesService} from "../../unidades/unidades.service";
import {Funcoes} from "../../funcoes";
import {Global} from "../../global";
import {ClientesLaudosPdfService} from "./clientes-laudos-pdf.service";
import {BasicValidators} from "../../shared/basic-validators";


@Component({
  selector: 'app-meus-laudos-pdf-form',
  templateUrl: './meus-laudos-pdf-form.component.html'
})
export class MeusLaudosPdfFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  laudo: any = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;

  listClientes = [];
  listMercadorias = [];
  listTerminal = [];
  listUnidades = [];

  comPDF: boolean = true;

  url = '';
  alturaTela;

  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private laudosService: ClientesLaudosPdfService,
    private clientesService: ClientesService,
    private mercadoriasService: MercadoriasService,
    private tiposClientesService: TiposClientesService,
    private unidadesService: UnidadesService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {

    route.params.subscribe(params => {
      this.url = global.dominio_site+'/cli/clientes-usuarios/meus-laudos-pdf/'+params['id_laudo']+'/pdf/?tk='+localStorage.getItem('token') + '&t=' + new Date().getTime();

      /*this.laudosService.existePDF(params['id_laudo'])
        .subscribe(
          json => {
            this.comPDF = true
          },
          error => {

          });*/
    });

    this.alturaTela = window.screen.availHeight - 250;

    this.form = formBuilder.group({
      id_laudo: [],
      terminal: [],
      mercadoria: [],
      data: [],
      referencia: [],
      fatura: [],
      container: [],
      conhecimento: [],
      id_status: [],
      pdf: []
    });

  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_laudo'];

      this.title = this.func.traduzir('front.visualizarLaudoPdf');

      if (!id) {
        return;
      }

      this.laudosService.getById(id)
        .subscribe(
          json => {
            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }

            this.laudo = json.Payload[0];
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/area-cliente/meus-laudos-pdf/meus-laudos-pdf-form.component.ts